// extracted by mini-css-extract-plugin
export const svgIcon = "font-or-svg-icon-module--svgIcon--1j0vA";